export default __webpack_public_path__ + "static/media/deleteIcon.b32611d0.svg";